<template>
  <page
    v-model:filter="q"
    :name="$t('I tuoi prodotti')"
    :title="$t('I tuoi prodotti')"
    :empty="!productOrder.length"
    :state="[paymentsState, productOrderState]"
    sticky
  >
    <template #toolbar-pre>
      <pf-toolbar-item ref="toolbar" v-if="loginStore.is_reseller && selected.length">
        <pf-dropdown :text="$t('Selezionati {0} prodotti', [selected.length]) + ': Modifica'" container-ouia-id="dropdown-action-multiple">
          <pf-dropdown-item @click="changeBillingDataModal = true" :ouia-id="'menu-item-change-billing-data'">
            {{ $t('Fattura prodotti direttamente a un mio cliente') }}
          </pf-dropdown-item>
        </pf-dropdown>
      </pf-toolbar-item>
      <pf-toolbar-item>
        <pf-button variant="secondary" :disabled="!productOrder.length" @click="csv()" :title="$t('Scarica CSV')">
          <template #icon>
            <file-csv-icon />
          </template>
        </pf-button>
      </pf-toolbar-item>
      <pf-toolbar-item ref="toolbar">
        <pf-dropdown :text="$t('Raggruppa per') + ': ' + groupByOption[groupBy]" container-ouia-id="dropdown-group-by">
          <pf-dropdown-item v-for="(value, key) in groupByOption" :key="key" @click.prevent="groupBy = key" :ouia-id="`menu-item-${key}`">
            {{ value }}
            <template #icon v-if="key === groupBy">
              <check-icon />
            </template>
          </pf-dropdown-item>
        </pf-dropdown>
      </pf-toolbar-item>
    </template>

    <pf-page-section no-body-wrapper v-for="(_rgroup, group) of groupedProducts" :key="group">
      <pf-title h="2" v-if="groupBy == 'renewal_date'">
        <template v-if="group == 'test'">{{ $t('Prodotti in prova') }}</template>
        <template v-else-if="group == 'canceled'">{{ $t('Prodotti scaduti da più di {0} giorni', [retentionDays]) }}</template>
        <template v-else-if="group == 'gracePeriod'">{{ $t('Prodotti scaduti da meno di {0} giorni', [retentionDays]) }}</template>
        <template v-else-if="group == 'scadenza3'">{{ $t('Prodotti che scadranno nei prossimi tre mesi') }}</template>
        <template v-else-if="group == 'scadenza12'">{{ $t('Prodotti che scadranno entro fine anno') }}</template>
        <template v-else-if="group == 'scadenzaFuture'">{{ $t('Altri con scadenza futura') }}</template>
        <template v-else>{{ $t('In scadenza entro fine mese') }}</template>
      </pf-title>
      <pf-title v-else>{{ group }}</pf-title>

      <product-list
        v-if="groupedProducts[group as keyof typeof groupedProducts].length"
        :products="groupedProducts[group as keyof typeof groupedProducts]"
        :payments="payments"
        @submit="productOrderState.update"
        @toggle-select="toggleSelect"
        :hide-domain-sort="groupBy === 'domain'"
        :filter="q"
        :ouia-id="`product-table-${group}`"
        :selectable="loginStore.is_reseller"
        :selected="selected"
      />
    </pf-page-section>

    <x-form
      v-if="loginStore.is_reseller && selected.length && changeBillingDataModal"
      modal
      open
      :title="$t('Fattura prodotti direttamente a un mio cliente')"
      ouia-id="modal-change-billing-data"
      variant="medium"
      @update:open="$event ? undefined : (changeBillingDataModal = false)"
      @submit="changeBillingSubmit"
    >
      <template #description>
        <pf-content>
          <p>
            {{
              $t(
                'Con questo form potrai richiedere di fatturare direttamente ad un tuo cliente alcuni dei prodotti ora fatturati alla tua azienda: {0}. I prodotti verranno fatturati a prezzo pieno e ti verranno poi calcolate le relative commissioni come da accordi.',
                [loginStore.azienda],
              )
            }}
          </p>
          <p>
            {{
              $t(
                'Inviando questo form riceverai una mail con un allegato che dovrai inviarci firmato dal legale rappresentante della tua azienda e di quella del cliente seleazionato. Ricevuto il modulo effettuaremo il cambio di intestazione',
              )
            }}
          </p>
          <p>
            {{
              $t('Se desideri invece modificare i dati di fatturazione della tua azienda {0}, ti chiediamo di aprire un ticket di assistenza.', [
                loginStore.azienda,
              ])
            }}
          </p>
        </pf-content>
      </template>

      <form-group :name="$t('Prodotti che verranno fatturati al cliente selezionato')">
        <textarea :value="selectedProductsList" disabled rows="8" style="width: 100%; resize: vertical" />
      </form-group>

      <form-group name="Cliente" required>
        <pf-flex>
          <pf-flex-item grow>
            <pf-form-select
              v-if="myCustomers.length"
              :model-value="changeBillingCustomer"
              @update:model-value="changeBillingCustomer = $as<string>($event)"
              :placeholder="$t('Seleziona un cliente')"
              ouia-id="select-customer"
              required
            >
              <pf-form-select-option v-for="customer in myCustomers" :key="customer.id" :value="customer.id">
                {{ customer.ragione_sociale }}
              </pf-form-select-option>
            </pf-form-select>
            <template v-else>
              {{ $t('Nessun cliente trovato, inserisci un nuovo cliente prima di procedere') }}
            </template>
          </pf-flex-item>

          <pf-flex-item>
            <pf-button @click="newCustomerModal = true" data-ouia-component-id="new-prospect-button" style="max-width: 300px" variant="link">
              {{ $t('Inserisci un nuovo cliente') }}
            </pf-button>
          </pf-flex-item>
        </pf-flex>
      </form-group>
    </x-form>

    <form-prospect
      v-if="newCustomerModal"
      modal
      v-model:open="newCustomerModal"
      :title="$t('Inserisci un nuovo cliente')"
      variant="medium"
      @submit="newCustomerSubmit()"
    />
  </page>
</template>

<style scoped lang="scss">
.price {
  text-align: right;
}
:deep(button.pf-v6-c-button),
:deep(a.pf-v6-c-button) {
  margin-right: 5px;
}
</style>

<script lang="ts" setup>
import { ref, type Ref, computed } from 'vue';
import { asyncComputed, asyncComputedList } from '@common/asyncComputed';
import {
  type ProductOrder,
  ProductOrdersResource,
  type ProductsExpiringPayments,
  ProductsExpiringPaymentsResource,
  MyCustomersResource,
  ChangeBillingRequestResource,
} from '@/resources';
import { DateTime, Interval } from 'luxon';
import { parseDateTime } from '@common/date';
import { $t as _t } from '@/i18n';
import { saveCSV, any } from '@common/utils';
import { useLoginStore } from '@/store/login';
import ProductList from '@/components/product-list.vue';
import FormProspect from '@/components/form-prospect.vue';
import FileCsvIcon from '@vue-patternfly/icons/file-csv-icon';
import CheckIcon from '@vue-patternfly/icons/check-icon';

const loginStore = useLoginStore();
type GroupByOption = 'renewal_date' | 'domain' | 'customer_note';
const groupByOption: Record<GroupByOption, string> = {
  renewal_date: _t('Data di rinnovo'),
  domain: _t('Nome a dominio'),
  customer_note: _t('Note'),
};

const { state: productOrderState, result: productOrder } = asyncComputedList(() => new ProductOrdersResource().get());
const { state: paymentsState, result: payments } = asyncComputed(
  () => new ProductsExpiringPaymentsResource().get(),
  {} as Record<number, ProductsExpiringPayments>,
);
const { state: myCustomersResult, result: myCustomers } = asyncComputedList(() => {
  if (loginStore.is_reseller) {
    return new MyCustomersResource().get();
  }
  return [];
});

const now = DateTime.now().startOf('day');

const q = ref(''); // search query
const groupBy: Ref<GroupByOption> = ref('renewal_date');
const selected = ref<number[]>([]);
const changeBillingDataModal = ref(false);
const changeBillingCustomer = ref<string | null>(null);
const newCustomerModal = ref(false);

const filteredProductOrder = computed(() => {
  return q.value ? productOrder.value.filter(any(q.value)) : productOrder.value;
});

const retentionDays = 10;
const endOfMonth = now.endOf('month');
const endOfYear = now.endOf('year');
const nextMonth = now.startOf('month').plus({ months: 1 });
const threeMonthsFuture = now.endOf('month').plus({ months: 3 });

function groupProductsByRenewalDate() {
  const grouped = {
    test: [] as ProductOrder[],
    canceled: [] as ProductOrder[],
    gracePeriod: [] as ProductOrder[],
    scadenza: [] as ProductOrder[],
    scadenza3: [] as ProductOrder[],
    scadenza12: [] as ProductOrder[],
    scadenzaFuture: [] as ProductOrder[],
  };

  for (const product of filteredProductOrder.value) {
    const dataFine = parseDateTime(product.data_fine);

    if (product.free_period > 0) {
      grouped.test.push(product);
      continue;
    }

    if (product.grace_period) {
      grouped.gracePeriod.push(product);
      continue;
    }

    if (product.days_to_expiration < 0) {
      grouped.canceled.push(product);
      continue;
    }

    // fine mese
    if (dataFine <= endOfMonth) {
      grouped.scadenza.push(product);
      continue;
    }
    // prossimi tre mesi
    if (Interval.fromDateTimes(nextMonth, threeMonthsFuture).contains(dataFine)) {
      grouped.scadenza3.push(product);
      continue;
    }

    // fine anno
    if (dataFine <= endOfYear) {
      grouped.scadenza12.push(product);
      continue;
    }

    // altri
    grouped.scadenzaFuture.push(product);
  }

  // unset empty array keys
  for (const k of Object.keys(grouped) as (keyof typeof grouped)[]) {
    if (grouped[k].length == 0) {
      Reflect.deleteProperty(grouped, k);
    }
  }

  return grouped;
}

function groupProductsByDomain() {
  const grouped: Record<string, ProductOrder[]> = {};

  let dominio = '';
  for (const product of filteredProductOrder.value) {
    dominio = product.dominio ?? '';
    if (!grouped[dominio]) {
      grouped[dominio] = [product];
    } else {
      grouped[dominio]?.push(product);
    }
  }

  return Object.fromEntries(Object.entries(grouped).sort());
}

function groupProductsByCustomerNote() {
  const grouped: Record<string, ProductOrder[]> = {};

  for (const product of filteredProductOrder.value) {
    if (!grouped[product.note_cliente ?? _t('Senza note')]) {
      grouped[product.note_cliente ?? _t('Senza note')] = [product];
    } else {
      grouped[product.note_cliente ?? _t('Senza note')]?.push(product);
    }
  }

  return Object.fromEntries(Object.entries(grouped).sort());
}

const groupedProducts = computed(() => {
  if (groupBy.value === 'domain') {
    return groupProductsByDomain();
  }

  if (groupBy.value === 'customer_note') {
    return groupProductsByCustomerNote();
  }

  return groupProductsByRenewalDate();
});

const selectedProductsList = computed(() => {
  return selected.value
    .map(id => {
      const product = productOrder.value.find(p => p.id === id);
      return product ? `* ${product.dominio} - ${product.nome}` : '';
    })
    .join('\n');
});

function toggleSelect(ids: number[]) {
  const allSelected = ids.every(id => selected.value.includes(id));

  if (allSelected) {
    selected.value = selected.value.filter(id => !ids.includes(id));
  } else {
    const newIds = ids.filter(id => !selected.value.includes(id));
    selected.value.push(...newIds);
  }
}

function csv() {
  const fields: (keyof ProductOrder)[] = ['id', 'dominio', 'codice', 'nome', 'note_cliente', 'qt', 'prezzo', 'sconto_minimo', 'data_fine', 'durata'];

  saveCSV(fields, productOrder.value, 'products.csv');
}

function newCustomerSubmit() {
  newCustomerModal.value = false;
  myCustomersResult.update();
}

async function changeBillingSubmit() {
  if (!changeBillingCustomer.value) {
    return;
  }

  await new ChangeBillingRequestResource().post({
    ids: selected.value,
    customer_id: Number(changeBillingCustomer.value),
  });

  selected.value = [];
  changeBillingCustomer.value = null;
  changeBillingDataModal.value = false;
}
</script>
